import { BonusAnalysisResult } from "@bonusmap/api-types";
import { BaseWebComponent } from "../base-components/base-web-component";
import { toastInfo } from "../../toasts";
/**
 * Questa è la classe base per i blocchi che mostrano il file analizzato
 * viene direttamente usata per i blocchi di testo semplice 
 * e può essere estesa per blocchi più complessi o di tipo diverso 
 * (es. date, ecc.)
 */
export class BlockAnalyzed extends BaseWebComponent {
    static override webComponentName: string = "block-analyzed";
    protected override _templateId: string = "block-analyzed";
    protected get analysData(): BonusAnalysisResult | null {
        const parent = this.closest('ba-panel') as any;
        return parent ? parent.currentAnalysData : null;
    }

    private _target: string = "";
    protected get target(): string {
        if (this._target === "") {
            const attr = this.getAttribute('target');
            if (attr) {
                this._target = attr;
            }
        }
        return this._target;
    }
    // altre proprietà derivate dagli attributi : label (il testo della label)
    // type non è più usato
    private _label: string;
    public get label(): string {
        if (!this._label) {
            const attr = this.getAttribute('label');
            this._label = attr || '';
        }
        return this._label;
    }
    private _src: string;
    public get src(): string {
        if (!this._src) {
            const attr = this.getAttribute('src');
            this._src = attr || '';
        }
        return this._src;
    }
    protected get targetElement(): HTMLElement | null {
        if (this.target) {
            return document.querySelector(this.target);
        }
        return null;
    }

    protected isValidValue(value: any): boolean {
        return value !== null && value !== undefined && value !== '';
    }

    protected get value(): any {
        if (this.analysData && this.src && this.analysData.hasOwnProperty(this.src)) {
            const v = this.analysData[this.src];
            return this.isValidValue(v) ? v : null;
        }
        return null;
    }
    protected appliedValue: any = null;
    // il valore potrebbe essere stato modificato dall'utente nella textarea o input
    protected collectActualValue(): any {
        const elSrc = this.querySelector('input, textarea') as HTMLInputElement | HTMLTextAreaElement;
        if (elSrc) {
            return elSrc.value;
        }
        return this.value;
    }
    protected applyValueToTarget() {
        const el = this.targetElement;
        if (el) {
            const value = this.collectActualValue();
            this.appliedValue = value;
            el['value'] = value !== null ? value : '';
            // genera evento di input per sincronizzare eventuali listener
            if(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
                el.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
        else {
            console.warn(`BlockAnalyzed: Target element not found for selector ${this.target}`);
        }
    }
    public applyFromExternal() {
        this.applyValueToTarget();
    }
    constructor() {
        super();
        this.classList.add('block-analyzed'); // per stile base
    }
    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            ...baseData,
            key: this.src,
            label: this.label,
            value: this.value
        };
    }
    protected notifyValueChanged() {
        toastInfo(`Valore ${this.label} applicato`);
    }
    protected setupEventHandlers() {
        this.on('click', '[data-apply]', (event: Event) => {
            event.preventDefault();
            this.applyValueToTarget();
            // segnala che il valore è cambiato
            this.classList.add('applied');
            this.notifyValueChanged();
        });
    }
    protected afterRender(): void {
        super.afterRender();
        this.setupEventHandlers();
    }
}